import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { DEMO_PATH } from '../data/site';

export function Reveal({ children, delay = 0, className = '', as: Tag = 'div' }) {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[Tag] || motion.div;

  if (reduceMotion) {
    return <Tag className={className}>{children}</Tag>;
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-60px' }}
      transition={{ duration: 0.65, delay, ease: [0.2, 0.7, 0.2, 1] }}
    >
      {children}
    </MotionTag>
  );
}

export function Eyebrow({ children }) {
  return <span className="a6-eyebrow">{children}</span>;
}

export function SectionHead({ eyebrow, title, lede, centered = false }) {
  return (
    <Reveal className={`a6-section-head${centered ? ' is-centered' : ''}`}>
      {eyebrow ? <Eyebrow>{eyebrow}</Eyebrow> : null}
      <h2 className="a6-h2">{title}</h2>
      {lede ? <p className="a6-lede">{lede}</p> : null}
    </Reveal>
  );
}

export function DemoCta({ variant = 'primary', children = 'Book a demo' }) {
  return (
    <Link className={`a6-btn a6-btn-${variant}`} to={DEMO_PATH}>
      {children}
      <ArrowUpRight size={17} strokeWidth={2.4} aria-hidden="true" />
    </Link>
  );
}

export function TextLink({ to, children }) {
  return (
    <Link className="a6-textlink" to={to}>
      {children}
      <ArrowRight size={16} strokeWidth={2.4} aria-hidden="true" />
    </Link>
  );
}

export function CtaBand({
  title = 'See your practice on autopilot.',
  body = 'A 30-minute walkthrough with a real practice scenario — your schedule, your payer mix, your workflows.',
}) {
  return (
    <section className="a6-section-tight">
      <div className="a6-container">
        <Reveal className="a6-cta-band">
          <h2>{title}</h2>
          <p>{body}</p>
          <DemoCta variant="light" />
        </Reveal>
      </div>
    </section>
  );
}
